import React from 'react';

const section = (title, children) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-gray-900 mb-4">{title}</h2>
    {children}
  </div>
);

const p = (text) => <p className="text-gray-600 leading-7 mb-3">{text}</p>;

const PrivacyPolicy = () => (
  <div className="bg-white py-16 md:py-24">
    <div className="mx-auto max-w-3xl px-6">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
      <p className="text-gray-500 mb-12">Last updated: April 2026</p>

      {section('1. Who We Are', <>
        {p('Cygnet Call Centre Ltd ("Cygnet", "we", "us", "our") is a UK-based call handling and virtual receptionist service. Our registered address is Suite 133, 981 Great West Road, Brentford, TW8 9DN.')}
        {p('We are registered with the Information Commissioner\'s Office (ICO) and take our data protection obligations seriously. This policy explains how we collect, use, and protect your personal data.')}
      </>)}

      {section('2. Data We Collect', <>
        {p('When you use our website or contact us, we may collect:')}
        <ul className="list-disc list-inside text-gray-600 leading-8 mb-3 space-y-1">
          <li>Your name, business name, email address, and phone number (via our contact form)</li>
          <li>Information about your business type and service requirements</li>
          <li>Technical data such as your IP address, browser type, and pages visited</li>
          <li>Communications you send to us by email or phone</li>
        </ul>
        {p('We do not collect sensitive personal data (such as health or financial data) through this website.')}
      </>)}

      {section('3. How We Use Your Data', <>
        {p('We use your data to:')}
        <ul className="list-disc list-inside text-gray-600 leading-8 mb-3 space-y-1">
          <li>Respond to your enquiries and provide our services</li>
          <li>Send you information about our services where you have requested it</li>
          <li>Improve our website and services</li>
          <li>Comply with our legal obligations</li>
        </ul>
        {p('We will never sell your data to third parties or use it for unsolicited marketing without your consent.')}
      </>)}

      {section('4. Legal Basis for Processing', <>
        {p('We process your personal data on the following legal bases:')}
        <ul className="list-disc list-inside text-gray-600 leading-8 mb-3 space-y-1">
          <li><strong>Legitimate interests</strong> — responding to business enquiries</li>
          <li><strong>Contract</strong> — fulfilling services you have requested</li>
          <li><strong>Legal obligation</strong> — where required by UK law</li>
          <li><strong>Consent</strong> — for any marketing communications</li>
        </ul>
      </>)}

      {section('5. Data Retention', <>
        {p('We retain your personal data only for as long as necessary to fulfil the purposes it was collected for, including legal, accounting, or reporting requirements.')}
        {p('Enquiry data is typically retained for 12 months. Client data is retained for the duration of the contract plus 6 years in line with UK business record-keeping requirements.')}
      </>)}

      {section('6. Your Rights', <>
        {p('Under UK GDPR, you have the right to:')}
        <ul className="list-disc list-inside text-gray-600 leading-8 mb-3 space-y-1">
          <li>Access the personal data we hold about you</li>
          <li>Request correction of inaccurate data</li>
          <li>Request erasure of your data</li>
          <li>Object to or restrict our processing of your data</li>
          <li>Request portability of your data</li>
          <li>Withdraw consent at any time (where consent is the legal basis)</li>
        </ul>
        {p('To exercise any of these rights, contact us at info@cygnetcall.co.uk.')}
      </>)}

      {section('7. Cookies', <>
        {p('Our website uses essential cookies to ensure the site functions correctly. We do not use tracking or advertising cookies. You can disable cookies in your browser settings, though this may affect site functionality.')}
      </>)}

      {section('8. Third-Party Services', <>
        {p('Our contact form uses Web3Forms to deliver enquiries to our inbox. Web3Forms processes submitted data in accordance with their own privacy policy. We do not share your data with any other third parties without your explicit consent, except where required by law.')}
      </>)}

      {section('9. Security', <>
        {p('We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction. We are ISO9001 certified and ICO registered.')}
      </>)}

      {section('10. Changes to This Policy', <>
        {p('We may update this policy from time to time. The date at the top of this page reflects the most recent update. Continued use of our website after changes constitutes acceptance of the updated policy.')}
      </>)}

      {section('11. Contact Us', <>
        {p('For any privacy-related queries or to exercise your rights, contact us at:')}
        <address className="not-italic text-gray-600 leading-8">
          Cygnet Call Centre Ltd<br />
          Suite 133, 981 Great West Road, Brentford, TW8 9DN<br />
          Email: <a href="mailto:info@cygnetcall.co.uk" className="text-cygnet-dark hover:underline">info@cygnetcall.co.uk</a><br />
          Phone: <a href="tel:+442085385400" className="text-cygnet-dark hover:underline">0208 538 5400</a>
        </address>
        {p('If you are unhappy with how we handle your data, you have the right to lodge a complaint with the Information Commissioner\'s Office (ICO) at ico.org.uk.')}
      </>)}
    </div>
  </div>
);

export default PrivacyPolicy;
